import { KeyValue } from "@/main/models/common";

export enum BodyshopTypeTypes {
	GET_BODYSHOP_TYPE = "@bodyshopType/GET_BODYSHOP_TYPE",
	SAVE_BODYSHOP_TYPE = "@bodyshopType/SAVE_BODYSHOP_TYPE",
	RESET_REDUCER_BODYSHOP_TYPE = "@bodyshopType/RESET_REDUCER_BODYSHOP_TYPE",
}

export interface BodyshopTypeState {
	readonly bodyshopType: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetBodyshopType {
	type: typeof BodyshopTypeTypes.GET_BODYSHOP_TYPE;
}

export interface SaveBodyshopType {
	type: typeof BodyshopTypeTypes.SAVE_BODYSHOP_TYPE;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerBodyshopType {
	type: typeof BodyshopTypeTypes.RESET_REDUCER_BODYSHOP_TYPE;
}

export type BodyshopTypeActionTypes = GetBodyshopType | SaveBodyshopType | ResetReducerBodyshopType;
